import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Container, Grid } from '@iho-design-system/Loader';

/*
    - component
*/
import List from '../components/passenger/List';
import Toolbar from '../components/passenger/Toolbar';

/*
    - api
*/
import getApi from '../api/get';

const Passenger = () => {

    /*
        - defaultData
    */
    const [passengerData, setPassengerData] = React.useState({
        nations: '',
        passengers: ''
    });
    const [reloadPassenger, setReloadPassenger] = React.useState('');

    /*
        - alertProps
    */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 2500);
    }

    /*
        - fetchData
    */
    React.useEffect(() => {
        const fetchData = async () => {
            let nationsParameters = {
                ctrl: 'common',
                method: 'GetAllNations',
                query: ''
            };
            let passengersParameters = {
                ctrl: 'SiteUserPassenger',
                method: 'GetPassengers',
                query: '?PageIndex=1&PageSize=10'
            }
            setPassengerData({
                nations: await getApi(nationsParameters),
                passengers: await getApi(passengersParameters),
            });
        }
        fetchData();
    }, [reloadPassenger]);

    /*
        - reloadPassengerProps
    */
    const reloadPassengerProps = (reloadPassengerProps) => {
        setReloadPassenger(reloadPassengerProps);
    }

    /*
        - nationalCodeSearchProps
    */
    const nationalCodeSearchProps = async (nationalCodeSearchProps) => {
        let parameters = {
            ctrl: 'SiteUserPassenger',
            method: 'GetPassengers',
            query: '?PageIndex=1&PageSize=10'
        };
        if (nationalCodeSearchProps !== '') {
            parameters.query = `?PageIndex=1&PageSize=10&NationalCode=${nationalCodeSearchProps}`;
        }
        setPassengerData({
            ...passengerData,
            passengers: await getApi(parameters)
        });
    }

    /*
        - paginationProps
    */
    const paginationProps = async (paginationProps) => {
        let parameters = {
            ctrl: 'SiteUserPassenger',
            method: 'GetPassengers',
            query: ''
        };
        if (Math.ceil(passengerData.passengers.data.TotalItems / passengerData.passengers.data.PageSize) >= passengerData.passengers.data.PageIndex + paginationProps && (passengerData.passengers.data.PageIndex + paginationProps) >= 1) {
            parameters.query = `?PageIndex=${passengerData.passengers.data.PageIndex + paginationProps}&PageSize=10`;
            setPassengerData({
                ...passengerData,
                passengers: await getApi(parameters)
            });
        }
    }

    /*
        - componentData
    */
    let toolbarData = [];
    toolbarData.nations = passengerData.nations;

    let listData = [];
    listData.nations = passengerData.nations;
    listData.passengers = passengerData.passengers;

    return (
        <React.Fragment>
            <Container
                size='lg'>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            <Toolbar
                                props={toolbarData}
                                alertProps={alertProps}
                                nationalCodeSearchProps={nationalCodeSearchProps}
                                reloadPassengerProps={reloadPassengerProps} />
                        </Grid.Item>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            <List
                                props={listData}
                                alertProps={alertProps}
                                paginationProps={paginationProps}
                                reloadPassengerProps={reloadPassengerProps} />
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Container>
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>
        </React.Fragment>
    );

}

export default Passenger;